'use client';

import React, { FC, useEffect, useState } from 'react';
import styles from './widget-blind.module.scss';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import {
  getBlindMode,
  setBlindMode,
  toggleBlindMode,
} from '../../../../../store/slices/blind-mode.slices';
import Cookies from 'js-cookie';

interface Props extends React.HTMLProps<HTMLDivElement> {
  white?: boolean;
}

export const WidgetBlind: FC<Props> = ({ white, ...props }) => {
  const { isCookiesData, blindWrapClass } = useAppSelector(getBlindMode);
  const dispatch = useAppDispatch();
  const [cookieValue, setCookieValue] = useState(Cookies.get('special'));

  const activatedBlindMode = () => {
    dispatch(toggleBlindMode());
  };

  useEffect(() => {
    let intervalTimerCookie = null;
    if (cookieValue || blindWrapClass) {
      dispatch(setBlindMode(true));
      intervalTimerCookie = setInterval(() => {
        const cookiesInterval = Cookies.get('special');
        if (!cookiesInterval) {
          setCookieValue(null);
          dispatch(setBlindMode(false));
        }
      }, 500);
    }

    return () => {
      clearInterval(intervalTimerCookie);
    };
  }, [cookieValue, isCookiesData]);

  if (white) {
    return (
      <div className={styles.widget} id="specialButton" onClick={activatedBlindMode}>
        <img
          src="/image/layout/blind-icon-mode-white.svg"
          alt="ВЕРСИЯ ДЛЯ СЛАБОВИДЯЩИХ"
          title="ВЕРСИЯ ДЛЯ СЛАБОВИДЯЩИХ"
        />
      </div>
    );
  }

  return (
    <div
      className={styles.widget}
      id="specialButton"
      {...props}
      onClick={activatedBlindMode}
    >
      <img
        src="/image/layout/blind-icon-mode.svg"
        alt="ВЕРСИЯ ДЛЯ СЛАБОВИДЯЩИХ"
        title="ВЕРСИЯ ДЛЯ СЛАБОВИДЯЩИХ"
      />
    </div>
  );
};
